<script lang="ts" setup>
  import { computed, onMounted, ref, watch } from 'vue';
  import { useStore } from 'vuex';
  import { themingCssClass } from "../../mixins/theming-mixin";
  import { recProps } from '../../mixins/rec-component';

  const props = defineProps({...recProps()});
  
  const store = useStore();
  const visitedKeys = ref<Array<string>>([]);

  const currentAreaKey = computed(() => store.state.exam.currentAreaKey);
  const moreThanOneElement = computed(() => ((props.description || {}).steps || []).length > 1)

  const select = (newKey: string) => {
    store.commit("updateCurrentAreaKey", newKey);
  };
  const bubbleCssClasses = (step: any) => {
    const result = [];

    result.push(themingCssClass("border"));

    if (step.key === currentAreaKey.value) {
      result.push("active");
      result.push(themingCssClass("inverted"));
    } else {
      result.push(themingCssClass("normal"));
    }
    if (visitedKeys.value.indexOf(step.key) >= 0) result.push("visited");

    return result;
  };

  watch(currentAreaKey, (newVal: any) => {
    if (visitedKeys.value.indexOf(newVal) < 0) {
      visitedKeys.value.push(newVal);
    }
  }, { immediate: true });
</script>

<template>
  <div class="components__rec-progress-bar">
    <div v-if="moreThanOneElement" class="bubbles">
      <div
        class="bubble"
        v-for="step in description.steps"
        v-bind:key="step.key"
        v-bind:class="bubbleCssClasses(step)"
        v-on:click="select(step.key)"
      >
        <div class="bubble-label">{{ step.label }}</div>
        <div class="bubble-text">{{ step.text }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.components__rec-progress-bar {
  $_bubble-margin: 8px;

  position: relative;
  margin-bottom: 20px - $_bubble-margin;

  .bubbles {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .bubble {
      border-radius: 5px;
      font-size: 14px;

      height: 30px;
      min-width: 30px;
      max-width: 50px;
      text-align: center;
      line-height: 30px;
      margin-right: $_bubble-margin;
      margin-bottom: $_bubble-margin;

      display: flex;
      justify-content: center;

      cursor: pointer;

      $_animation_max_width: 700px;
      $_animation_duration: 0.75s;
      $_animation_function: linear;

      .bubble-text {
        max-width: 0;
        overflow: hidden;
        transition: all $_animation_duration $_animation_function;
      }

      .bubble-label {
        padding-left: 10px;
        padding-right: 10px;
      }

      transition: max-width $_animation_duration $_animation_function;
      &:hover,
      &.active {
        max-width: $_animation_max_width;
        transition: max-width $_animation_duration $_animation_function;
        text-align: left;

        .bubble-text {
          max-width: $_animation_max_width;
          transition: max-width $_animation_duration $_animation_function;
          margin-right: 15px;
        }
      }
    }
  }
}
</style>
